<template>
  <section class="mall">
    <div class="center">
      <h3>福利商城的作用</h3>
      <p>企业文化宣导、提高员工工作积极性、提供全方位评估依据</p>
      <div class="content">
        <div class="lf pic">
          <img src="@/assets/image/mall.png"/>
          <ul>
            <li>制定福利计划</li>
            <li>后台发放积分</li>
            <li>员工登录</li>
            <li>自主兑换</li>
            <li>送货上门</li>
          </ul>
        </div>
        <div class="rt msg">
          <div>商城使用步骤</div>
          <P>HR全程线上操作，省去选品、采购等复杂流程，工作流程更简单。</P>
          <p>员工自主选择心仪礼品，自行兑换，丰富选择，员工更满意。</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Mall',
  props: {
  }
}
</script>
<style scoped lang="less">
.mall {
  height: 500px;
  width: 100%;
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    color:@text-color;
    text-align: center;
    overflow: hidden;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      line-height:42px;
      margin-top: 58px;
    }
    p {
      font-size:18px;
      font-family: @PingFangSC-Regular;
      font-weight:400;
      line-height:25px;
      margin-top: 10px;
    }
    .content {
      padding: 0px 35px;
      margin-top: 110px;
      .pic {
        img {
          width: 727px;
          height: 90px;
          margin-bottom: 14px;
        }
        ul {
          overflow: hidden;
          li {
            float: left;
            font-size:16px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            line-height:22px;
            margin-right: 70px;
          }
          li:nth-child(2) {
            margin-right: 75px;
          }
          li:nth-child(3) {
            margin-right: 100px;
          }
          li:nth-child(4) {
            margin-right: 90px;
          }
          li:last-child {
            margin-right: 0px;
          }
        }
      }
      .msg {
        width: 304px;
        text-align: left;
        div {
          font-size:22px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          line-height:30px;
          margin-bottom: 11px;
        }
        p {
          font-size:14px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          line-height:20px;
          margin-bottom: 17px;
        }
      }
    }
  }
}
</style>
